import styled from 'styled-components';

import { BaseStyle, Button } from '@nhl/nhl-breakaway-ui';

import { StrictWidthContainer } from '~/views/components/strictWidthText/styles';

export const ButtonContainer = styled.div`
    ${BaseStyle.Mixins.gaps.small}
    display: flex;
`;

export const VideoButton = styled(Button)`
    ${BaseStyle.Mixins.gaps.extraSmall}
    color: ${({ theme }) => theme.Utility.cta};
    height: 44px;
    flex-grow: 1;
    flex-basis: 0;
    min-width: 0;
    padding: 4px;

    svg {
        ${BaseStyle.Mixins.fontStyles.ui['24m']}
        fill: ${({ theme }) => theme.Utility.cta};
    }

    ${StrictWidthContainer} {
        color: ${({ theme }) => theme.Utility.cta};
        line-height: 16px;
    }
`;
